var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCashRegister = function SvgCashRegister(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    x: "0px",
    y: 0,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126,110.9l-6-62a1,1,0,0,0-1-.9H104V26h17a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H77a1,1,0,0,0-1,1V25a1,1,0,0,0,1,1H94V48H49V21a1,1,0,0,0-1.274-.962L41,21.96l-6.726-1.922a1,1,0,0,0-.548,0L27,21.96l-6.726-1.922A1,1,0,0,0,19,21V48H9a1,1,0,0,0-.995.9l-6,62c0,.033.011.064.011.1H2v14a1,1,0,0,0,1,1H125a1,1,0,0,0,1-1V111h-.016C125.984,110.967,126,110.936,126,110.9ZM78,4h42V24H78ZM96,26h6V48H96ZM26.726,23.962a1,1,0,0,0,.548,0L34,22.04l6.726,1.922a1,1,0,0,0,.548,0L47,22.326V28H46v2h1V60H21V30h1V28H21V22.326ZM9.908,50H19V60H17v2H51V60H49V50h69.092l5.806,60H4.1ZM4,124V112H124v12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67,64h42a3,3,0,0,0,3-3V57a3,3,0,0,0-3-3H67a3,3,0,0,0-3,3v4A3,3,0,0,0,67,64Zm-1-7a1,1,0,0,1,1-1h42a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H67a1,1,0,0,1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116,7H82a1,1,0,0,0-1,1V20a1,1,0,0,0,1,1h34a1,1,0,0,0,1-1V8A1,1,0,0,0,116,7Zm-1,12H83V9h32Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashRegister, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash-register.82e1c9e2.svg";
export { ForwardRef as ReactComponent };